module.exports = __webpack_public_path__ + "96f8b5e7eaa700850ecc59931969f964.png";